import ItemViewState from '../store/schema/ItemViewState';
import setIsRecipientWellTruncated from '../actions/setIsRecipientWellTruncated';
import { mutator } from 'satcheljs';

export default mutator(
    setIsRecipientWellTruncated,
    function setIsRecipientWellTruncatedMutator(actionMessage: {
        viewState: ItemViewState;
        valueToSet: boolean;
    }) {
        const { viewState, valueToSet } = actionMessage;
        viewState.isRecipientWellTruncated = valueToSet;
    }
);
